export default [
  { icon: 'smart-home', title: 'DASHBOARD', link: '/', routerLinkExact: true },
  { icon: 'bell', title: 'NOTIFICATION', link: '/notifications', routerLinkExact: false },
  { icon: 'pill', title: 'MEDICATION', link: '/medications', routerLinkExact: false },
  { icon: 'photo', title: 'IMAGE', link: '/images', routerLinkExact: false },
  { icon: 'report-analytics', title: 'WEEKLY_REPORT', link: '/weekly-reports', routerLinkExact: false },
  { icon: 'users', title: 'USER', link: '/users', routerLinkExact: false }
];